import React, { useMemo } from 'react';

export default function TeamMotivationBar({ repRows = [], teamGoal = 50, rangeLabel = '' }) {
  const top = repRows[0];
  const totalCalls = repRows.reduce((s, r) => s + r.metrics.total, 0);
  const totalTermine = repRows.reduce((s, r) => s + r.metrics.termin, 0);
  const progress = teamGoal > 0 ? Math.min(100, Math.round((totalCalls / teamGoal) * 100)) : 0;

  const medals = useMemo(() => repRows.slice(0, 3).map((r, i) => ({
    ...r,
    medal: ['🥇', '🥈', '🥉'][i],
  })), [repRows]);

  if (!repRows.length) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(15,138,83,0.08), rgba(249,115,22,0.06))',
      border: '1px solid var(--border)', borderRadius: 14, padding: '16px 18px', marginBottom: 20,
    }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)' }}>Team-Power {rangeLabel}</div>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 4 }}>
            {totalCalls} Anrufe · {totalTermine} Termine gesetzt
            {top && <span> · Spitzenreiter: <strong style={{ color: 'var(--accent)' }}>{top.label}</strong></span>}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {medals.map(m => (
            <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'var(--bg2)', borderRadius: 10, padding: '6px 12px', border: '1px solid var(--border)' }}>
              <span style={{ fontSize: 18 }}>{m.medal}</span>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600 }}>{m.label}</div>
                <div style={{ fontSize: 11, color: 'var(--text3)' }}>{m.metrics.total} Anrufe · {m.metrics.termin} Termine</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {teamGoal > 0 && (
        <div style={{ marginTop: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--text3)', marginBottom: 4 }}>
            <span>Team-Ziel Anrufe</span>
            <span>{totalCalls} / {teamGoal} ({progress}%)</span>
          </div>
          <div style={{ height: 8, borderRadius: 4, background: 'var(--bg4)', overflow: 'hidden' }}>
            <div style={{ width: `${progress}%`, height: '100%', background: progress >= 100 ? '#16a34a' : '#0f8a53', borderRadius: 4, transition: 'width .4s' }} />
          </div>
        </div>
      )}
    </div>
  );
}
